import React from "react";
const Booking = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M21.474 3.79v17.763H2.526V3.789h18.948zm-1.185 4.736H3.711v11.842h16.578V8.526zm-2.368 7.106V18h-2.368v-2.368h2.368zm-4.737 0V18h-2.368v-2.368h2.368zm-4.737 0V18H6.08v-2.368h2.368zm0-4.737v2.368H6.08v-2.368h2.368zm4.737 0v2.368h-2.368v-2.368h2.368zm4.737 0v2.368h-2.368v-2.368h2.368zm2.368-5.921H3.711v2.37h16.578v-2.37z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    stroke: "currentColor",
    d: "M16.921 3.026H17.921V5.8149999999999995H16.921zM6.816 3.026H7.816V5.8149999999999995H6.816z"
  }
)));
var Booking_default = Booking;
export {
  Booking_default as default
};
//# sourceMappingURL=Booking.js.map
